var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _polyline, _line, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTraceProfilesLarge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 148,
    height: 108,
    viewBox: "0 0 148 108",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M146.36772,98.88314c-13.98034,.22769-49.53941,1.00248-60.47317,.50124,3.64873-9.94795,2.93044-17.79453,2.0073-22.00945",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.52162
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.72034,78.05372s-9.51083,.88351-19.71032-4.09578c-19.07208-11.66786-17.01629-29.35857-11.24552-35.26239,0,0,4.75413,8.46926,21.66346,8.07837",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.52162
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.29906,5.07974s15.87565,3.8365,19.18345,13.48653c2.81751,8.21971-.27369,13.20238-4.4409,13.18649-4.26775-.01628-7.44575-6.74903-6.07323-13.39512,1.0983-5.31824,6.79081-11.38855,12.03943-12.3936",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.52162
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.24415,70.39344c.11988,.77903-7.22462,35.34816-9.02285,35.45945-1.79823,.11129-8.26172,.10287-8.26172,.10287,0,0,4.91727-7.08368,7.24583-22.61817,0,0-2.50836-4.5829-2.8983-10.84319",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.52162
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.75798,78.5629c-.01678,5.39181,1.90943,16.78504,1.20061,19.90452-.70882,3.11948-3.67438,7.89784-3.46436,7.94658,0,0,5.64372,1.10055,8.89105-.03334,1.67166-.5837,.86381-5.16033,1.17636-17.04705,.20921-7.95679,7.14923-15.16614,7.14923-15.16614",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.52162
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.01273,28.12983c1.48727-1.29194,4.69313-14.02099,4.69313-14.02099",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.52162
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.39364,13.71258c4.84744-5.36469,12.9061-8.29524,12.58784-8.16216-2.39305,1.00066-3.02185,7.7374-3.02185,7.7374,0,0,4.64101,14.25361,5.24521,16.21676,.6042,1.96314,4.20212,2.65069,7.22313,2.65069",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.52162
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1.63228,105.60232c7.49766,.05048,41.57091,1.41934,43.13927-.33243,1.56837-1.75177,3.02891-5.33871,2.35255-12.2624-.78491-8.03487-3.56712-15.56185-2.96328-15.4657,33.2426,5.2935,54.008-23.94717,36.37374-49.41197,0,0,4.10309,34.54024-37.3996,31.41313",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.52162
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5309,12.56076c3.61477-.12907,15.68988-.30156,17.93484,10.19616,2.24496,10.49772-8.81508,9.96476-9.59377,3.16061-.62619-5.4717,1.58378-9.03724,1.58378-9.03724",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.52162
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M56.70587,14.10884c.30928-.24388-1.36531-12.52191-11.81368-13.00143-10.44837,.47952-12.24184,11.93653-11.93256,12.18041",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.52162
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "42.91564 22.83772 45.32405 24.41169 47.85426 22.81052",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.52162
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 45.32405,
    y1: 24.41169,
    x2: 45.32405,
    y2: 30.86309,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.52162
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M75.30002,78.11433s17.19109,3.99185,25.61866-17.54894",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.52162
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9738,73.96071s15.12709,1.63276,18.66194-14.43625c2.53976-11.54546-5.48277-31.51408-27.74119-33.77588",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.52162
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTraceProfilesLarge);
export default __webpack_public_path__ + "static/media/icon-trace-profiles-large.036169842b08be0b63cb8c9bd7ecbb48.svg";
export { ForwardRef as ReactComponent };